module.exports = __webpack_public_path__ + "img/newsImg11-28.7fed9dd3.png";